export default {
  'epac-connect': {
    name: 'Epac Connect',
    features: {
      'editor:authentication': {
        is_available: false
      },
      // Scan Result Tab
      'editor:scan-result': {
        is_available: false
      },
      // 'editor:scan-result:logo': {
      //   is_available: false
      // },
      // 'editor:scan-result:display-mode': {
      //   is_available: false
      // },
      // 'editor:scan-result:text': {
      //   is_available: false
      // },
      // 'editor:scan-result:branding': {
      //   is_available: false
      // },
      // 'editor:scan-result:serial-number': {
      //   is_available: false
      // },

      // Global Settings Tab
      'editor:global': {
        is_available: false
      },

      // 'editor:global:languages': {
      //   is_available: true,
      //   has_limit: true,
      //   limit: 1
      // },
      'editor:global:title': {
        is_available: false
      },

      // Design Tab
      'editor:design': {
        is_available: false
      },

      // Editor Tab
      'editor:tabs': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:settings': {
        is_available: false
      },
      'editor:tabs:create': {
        is_available: false
      },
      'editor:tabs:tools:product_image': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_name': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_description': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:image': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:image:link': {
        is_available: false
      },
      'editor:tabs:tools:text': {
        is_available: false
      },
      'editor:tabs:tools:large_text': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:button': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:gallery': {
        is_available: false,
        limit: 1,
        disable_delete: false
      },
      'editor:tabs:tools:typeform': {
        is_available: false,
        disable_delete: false,
        disable_edit: true
      },
      'editor:tabs:tools:social': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:divider': {
        is_available: false
      },
      'editor:tabs:tools:video': {
        is_available: false
      },
      'editor:tabs:tools:iframe': {
        is_available: false
      },
      'editor:tabs:tools:consume': {
        is_available: false
      },
      'editor:richtext': {
        is_available: false
      },
      'editor:redirect:url': {
        is_available: false
      },
      'editor:redirect:product': {
        is_available: false
      }
    }
  },
  'epac-connect-plus': {
    name: 'Epac Connect Plus',
    features: {
      'editor:authentication': {
        is_available: false
      },
      // Scan Result Tab
      'editor:scan-result:logo': {
        is_available: false
      },
      'editor:scan-result:display-mode': {
        is_available: false
      },
      'editor:scan-result:text': {
        is_available: false
      },
      'editor:scan-result:branding': {
        is_available: false
      },
      'editor:scan-result:serial-number': {
        is_available: false
      },

      // Global Settings Tab
      'editor:global': {
        is_available: true
      },

      'editor:global:languages': {
        is_available: true
      },

      // Design Tab
      'editor:design': {
        is_available: true
      },

      // Editor Tab
      'editor:tabs': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_image': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_name': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_description': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:image': {
        is_available: true,
        has_limit: true,
        limit: 10
      },
      'editor:tabs:tools:image:link': {
        is_available: false
      },
      'editor:tabs:tools:text': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:large_text': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:button': {
        is_available: true,
        has_limit: true,
        limit: 2
      },
      'editor:tabs:tools:typeform': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:divider': {
        is_available: false
      },
      'editor:tabs:tools:video': {
        is_available: false
      },
      'editor:tabs:tools:iframe': {
        is_available: false
      },
      'editor:tabs:tools:social': {
        is_available: false
      },
      'editor:tabs:tools:consume': {
        is_available: false
      },
      'editor:richtext': {
        is_available: true
      },

      'editor:redirect:url': {
        is_available: true
      },
      'editor:redirect:product': {
        is_available: true
      }
    }
  },
  'epac-connect-premium': {
    name: 'Epac Connect Premium',
    features: {
      // Scan Result Tab
      'editor:authentication': {
        is_available: false
      },
      'editor:scan-result': {
        is_available: true
      },
      'editor:scan-result:logo': {
        is_available: true
      },
      'editor:scan-result:display-mode': {
        is_available: true
      },
      'editor:scan-result:text': {
        is_available: true
      },
      'editor:scan-result:branding': {
        is_available: true
      },
      'editor:scan-result:serial-number': {
        is_available: true
      },

      // Global Settings Tab
      'editor:global': {
        is_available: true
      },

      'editor:global:languages': {
        is_available: true
      },

      // Design Tab
      'editor:design': {
        is_available: true
      },

      // Editor Tab
      'editor:tabs': {
        is_available: true,
        has_limit: true,
        limit: 4
      },
      'editor:tabs:tools:product_image': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_name': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_description': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:settings': {
        is_available: true
      },
      'editor:tabs:create': {
        is_available: true
      },

      'editor:tabs:tools:image': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:image:link': {
        is_available: false
      },
      'editor:tabs:tools:text': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:button': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:large_text': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:typeform': {
        is_available: true
      },
      'editor:tabs:tools:social': {
        is_available: true
      },
      'editor:tabs:tools:divider': {
        is_available: true
      },
      'editor:tabs:tools:video': {
        is_available: true
      },
      'editor:tabs:tools:iframe': {
        is_available: true
      },
      'editor:tabs:tools:consume': {
        is_available: false
      },
      'editor:richtext': {
        is_available: true
      },

      'editor:redirect:url': {
        is_available: true
      },

      'editor:redirect:product': {
        is_available: true
      }
    }
  },
  'saas-free': {
    name: 'Scantrust Free',
    features: {
      'editor:authentication': {
        is_available: false
      },
      // Scan Result Tab
      'editor:scan-result:logo': {
        is_available: false
      },
      'editor:scan-result:display-mode': {
        is_available: false
      },
      'editor:scan-result:text': {
        is_available: false
      },
      'editor:scan-result:branding': {
        is_available: false
      },
      'editor:scan-result:serial-number': {
        is_available: false
      },

      // Global Settings Tab
      'editor:global': {
        is_available: true
      },

      'editor:global:languages': {
        is_available: true
      },

      // Design Tab
      'editor:design': {
        is_available: true
      },

      // Editor Tab
      'editor:tabs': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_image': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_name': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:product_description': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:image': {
        is_available: true,
        has_limit: true,
        limit: 10
      },
      'editor:tabs:tools:image:link': {
        is_available: true
      },
      'editor:tabs:tools:text': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:large_text': {
        is_available: true,
        has_limit: true,
        limit: 1
      },
      'editor:tabs:tools:button': {
        is_available: true,
        has_limit: true,
        limit: 2
      },
      'editor:tabs:tools:typeform': {
        is_available: true,
        has_limit: false
      },
      'editor:tabs:tools:social': {
        is_available: true,
        has_limit: true,
        limit: 3
      },
      'editor:tabs:tools:divider': {
        is_available: true
      },
      'editor:tabs:tools:video': {
        is_available: true
      },
      'editor:tabs:tools:iframe': {
        is_available: true
      },
      'editor:tabs:tools:consume': {
        is_available: false
      },
      'editor:richtext': {
        is_available: true
      },

      'editor:redirect:url': {
        is_available: true
      },
      'editor:redirect:product': {
        is_available: true
      }
    }
  }
}

// < text - edit : ref = "`text-edit-${toolKey}-${tabId}`" v -if= "type === 'text' && toolData:content" : content:sync = "toolData:content[lang]" ></text - edit >
// <image-edit :ref="`image-edit-${toolKey}-${tabId}`" v-if="type == 'image'" :src:sync="toolData:src[lang]"></image-edit>
// <button-edit :ref="`button-edit-${toolKey}-${tabId}`" v-if="type === 'button' && toolData:content" :content:sync="toolData:content[lang]" :url:sync="toolData:url[lang]"></button-edit>
// <divider-edit v-if="type === 'divider' && toolData:content" :content:sync="toolData:content[lang]"></divider-edit>
// <typeform-edit v-if="type === 'typeform' && toolData:content" :content:sync="toolData:content[lang]" :url:sync="toolData:url[lang]"></typeform-edit>
// <social-edit :ref="`social-edit-${toolKey}-${tabId}`" v-if="type === 'social' && toolData:content" :content:sync="toolData:content[lang]" :url:sync="toolData:url[lang]" :icon:sync="toolData:icon"></social-edit>
// <video-edit v-if="type === 'video' && toolData:content" :content:sync="toolData:content[lang]"></video-edit>
// <iframe-edit v-if="type === 'iframe'" :url:sync="toolData:url[lang]" :height:sync="toolData:height[lang]"></iframe-edit>
// <consume-edit :ref="`consume-edit-${toolKey}-${tabId}`" :content:sync="toolData:content[lang]" :consumed:sync="toolData:consumed[lang]" :button:sync="toolData:button[lang]" :mode:sync="toolData:mode" v-if="type === 'consume'"></consume-edit>
